import React from "react";
import Component from ".";

export default {
  title: "MainApp/organisms/GenericTable/Item",
};

const app = {
  id: "0",
  name: "Rivadulla",
  document: "38337229R",
  ubication: "España. Andalucía. Almería. Abla.",
  status: "PEN",
};


const columns = [
  {
    name: 'name',
    pill: false,
    mobileTag: false,
  },
  {
    name: 'document',
    pill: false,
    mobileTag: 'Documento:',
  },
  {
    name: 'ubication',
    pill: false,
    mobileTag: 'Ubicacion:'
  },
  {
    name: 'status',
    pill: true,
    mobileTag: false,
    pillMap: {
      INT: 'Integrado',
      NOT: 'No Integrado',
      PEN: 'Pendiente de Integración'
    },
    pillMapColor: {
      INT: '#3C7AF5',
      NOT: '#62D862',
      PEN: '#A65BE8'
    },
  }
];

export const GenericTableItem = () => {
  return <Component item={app} columns={columns} />;
};
